<div class="card">
    <div class="card-body">
        <h5 class="card-title">Tìm kiếm nhật ký</h5>
        <form [formGroup]="searchForm">
            <div class="row">
                <div class="col">
                    <app-input-text label="Tài khoản" placeholder="Nhập tài khoản" [formGroup]="searchForm" formControlName="accountIdLike"></app-input-text>
                </div>
                <div class="col">
                    <app-input-text label="Mã ứng dụng" placeholder="Nhập mã ứng dụng" [formGroup]="searchForm" formControlName="createApplicationCodeLike"></app-input-text>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <app-input-text label="Người thực hiện" placeholder="Nhập người thực hiện" [formGroup]="searchForm" formControlName="createUsernameLike"></app-input-text>
                </div>
                    <div class="col">
                        <app-input-text label="Dữ liệu" placeholder="Nhập dữ liệu" [formGroup]="searchForm" formControlName="loggingDataLike"></app-input-text>
                    </div>
            </div>
            <div class="row">
                <div class="col">
                    <app-input-select label="Thao tác" placeholder="Chọn thao tác" [formGroup]="searchForm" formControlName="action" [optionList]="loggingActionOptionList"></app-input-select>
                </div>
                <div class="col">
                    <app-input-select label="Trạng thái" placeholder="Chọn trạng thái" [formGroup]="searchForm" formControlName="status" [optionList]="loggingStatusOptionList"></app-input-select>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <app-input-date label="Từ ngày" placeholder="Nhập từ ngày"[formGroup]="searchForm" formControlName="createDateGt"></app-input-date>
                </div>
                <div class="col">
                    <app-input-date label="Đến ngày" placeholder="Nhập đến ngày"[formGroup]="searchForm" formControlName="createDateLt"></app-input-date>
                </div>
            </div>
        </form>
        <div class="d-flex justify-content-center">
        <div class="btn-group">
            <button type="button" class="btn btn-primary" (click)="searchLogging()" [disabled]="loading"><span *ngIf="loading"  class="spinner-border spinner-border-sm"></span>Tìm kiếm</button>
        </div>
    </div>
    </div>
</div>
<div class="card">
    <div class="card-body">
        <h5 class="card-title">Kết quả tìm kiếm</h5>
        <div class="alert alert-danger" role="alert" *ngIf="error">
          {{error}}
        </div>
        <div class="table-responsive">
        <table class="table table-striped table-hover">
            <thead>
                <tr>
                    <th scope="col">#</th>
                    <th scope="col">Thao tác</th>
                    <th scope="col">Dữ liệu</th>
                    <th scope="col">Tài khoản</th>
                    <th scope="col">Từ ứng dụng</th>
                    <th scope="col">Người thực hiện</th>
                    <th scope="col">Ngày thực hiện</th>
                    <th scope="col">Trạng thái</th>
                    <th scope="col">
                    </th>
                </tr>
            </thead>
            <tbody *ngIf="otpLoggingList && !loading">
                <tr *ngFor="let otpLogging of otpLoggingList;index as otpLoggingIndex">
                    <td scope="col">{{(otpLoggingPagination.currentPage-1)*otpLoggingPagination.pageSize + otpLoggingIndex+1}}</td>
                    <td scope="col">{{loggingActionOptionMap[otpLogging.action]}}</td>
                    <td scope="col">{{otpLogging.loggingData}}</td>
                    <td scope="col">{{otpLogging.accountId}}</td>
                    <td scope="col">{{otpLogging.createApplicationCode}}</td>
                    <td scope="col">{{otpLogging.createUsername}}</td>
                    <td scope="col">{{otpLogging.createDate | date:'dd/MM/yyyy, HH:mm:ss'}}</td>
                    <td scope="col">{{loggingStatusOptionMap[otpLogging.status]}}</td>
                    <td scope="col">
                        <div class="btn-group">
                            <button type="button" class="btn btn-info" (click)="viewLogging(otpLogging)">Xem</button>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
        </div>
        <div class="d-flex justify-content-between align-items-center"  *ngIf="otpLoggingPagination.pageCount>1 && !loading">
            <nav>
                <ul class="pagination">
                    <li class="page-item" [ngClass]="{'disabled':otpLoggingPagination.currentPage == 1}">
                      <a class="page-link" (click)="otpLoggingPageChange(otpLoggingPagination.currentPage-1)">Trước</a>
                    </li>
                    <li class="page-item" *ngIf="otpLoggingPagination.currentPage > 3">
                      <a class="page-link" (click)="otpLoggingPageChange(1)">1</a>
                    </li>
                  <li class="page-item disabled" *ngIf="otpLoggingPagination.currentPage > 3">
                    <a class="page-link" >...</a>
                  </li>
                  <li class="page-item" *ngFor="let page of otpLoggingPagination.pageList"  [ngClass]="{'active':otpLoggingPagination.currentPage == page}">
                    <a class="page-link" (click)="otpLoggingPageChange(page)">{{page}}</a>
                  </li>
                  <li class="page-item disabled" *ngIf="otpLoggingPagination.currentPage < otpLoggingPagination.pageCount - 2">
                    <a class="page-link" >...</a>
                  </li>
                  <li class="page-item" *ngIf="otpLoggingPagination.currentPage < otpLoggingPagination.pageCount - 2">
                    <a class="page-link" (click)="otpLoggingPageChange(otpLoggingPagination.pageCount)">{{otpLoggingPagination.pageCount}}</a>
                  </li>
                  <li class="page-item" [ngClass]="{'disabled':otpLoggingPagination.currentPage == otpLoggingPagination.pageCount}">
                    <a class="page-link"  (click)="otpLoggingPageChange(otpLoggingPagination.currentPage+1)">Sau</a>
                  </li>
                </ul>
              </nav>
        </div>
    </div>
</div>